import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { RECEIVE_TYPE } from "../actionTypes.js";
export default function createReceive(endpoint, _ref) {
  var args = _ref.args,
      response = _ref.response,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error;

  var _endpoint$errorExpiry, _endpoint$dataExpiryL;

  var expiryLength = error ? (_endpoint$errorExpiry = endpoint.errorExpiryLength) != null ? _endpoint$errorExpiry : 60000 : (_endpoint$dataExpiryL = endpoint.dataExpiryLength) != null ? _endpoint$dataExpiryL : 1000;
  /* istanbul ignore next */

  if (process.env.NODE_ENV === 'development' && expiryLength < 0) {
    throw new Error('Negative expiry length are not allowed.');
  }

  var now = Date.now();
  var meta = {
    schema: endpoint.schema,
    key: endpoint.key.apply(endpoint, _toConsumableArray(args)),
    args: args,
    date: now,
    expiresAt: now + expiryLength,
    errorPolicy: endpoint.errorPolicy
  };
  meta.update = endpoint.update;
  var action = {
    type: RECEIVE_TYPE,
    payload: response,
    endpoint: endpoint,
    meta: meta
  };
  if (error) action.error = true;
  return action;
}
/** Future action shape
{
  type: RECEIVE_TYPE,
  endpoint,
  payload,
  meta: {
    args,
    date,
    expiresAt,
  },
  error?: true,
} */